import script from "./GeneratedContent.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratedContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__